import React from "react";
import { Container, Card, CardContent, Typography } from "@mui/material";
import "./About.css"; // Optional custom CSS for additional styling

const About = () => {
  return (
    <Container className="about-container mt-5">
      <Card className="shadow-lg">
        <CardContent>
          <Typography variant="h4" component="h1" className="text-center mb-4">
            About Us
          </Typography>
          <Typography variant="body1" className="mb-3">
            Welcome to our e-commerce platform! We are dedicated to providing
            you with the best online shopping experience, offering a wide range
            of products tailored to your needs.
          </Typography>
          <Typography variant="body1" className="mb-3">
            Our mission is to deliver high-quality products at competitive
            prices while ensuring excellent customer service. Whether you're
            looking for the latest reading books related tech and all stuffs, we've got you covered.
          </Typography>
          <Typography variant="body1">
            Thank you for choosing our platform. We hope you enjoy your shopping
            journey!
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default About;
